module.exports = __webpack_public_path__ + "img/0.bdaf3873.jpg";